import moment from "moment";

/** Format API lifecycle timestamps for display. */
export const formatLifecycleDate = (value) => {
  if (!value) return "—";
  const m = moment(value);
  return m.isValid() ? m.format("YYYY-MM-DD") : "—";
};

/** Prefer lifecycle field, then fall back to older timestamp fields. */
export const getSubmissionDate = (app) =>
  app?.submissionDate ||
  app?.submitted_at ||
  app?.submitted_date ||
  app?.updated_at ||
  app?.created_at ||
  null;

export const getApprovalDate = (app) =>
  app?.approvalDate || app?.approved_at || null;

export const getRejectionDate = (app) =>
  app?.rejectionDate || app?.rejected_at || null;

export const getDueDate = (app) =>
  app?.due_date || app?.dueDate || app?.expiry_date || null;

export const getCreatedDate = (app) =>
  app?.created_at || app?.createdAt || null;

/**
 * Resolve the date field used by a given table/filter kind.
 * kind: "submitted" | "approved" | "rejected" | "created" | "due"
 */
export const getDateForKind = (app, kind) => {
  switch (kind) {
    case "approved":
      return getApprovalDate(app);
    case "rejected":
      return getRejectionDate(app);
    case "due":
      return getDueDate(app);
    case "created":
      return getCreatedDate(app);
    case "submitted":
    default:
      return getSubmissionDate(app);
  }
};

/**
 * Build lifecycle date-range query params for GET /applications.
 * kind: "submitted" | "approved" | "rejected" | "created" | "due"
 */
export const buildLifecycleDateParams = (kind, startDate, endDate) => {
  const params = {};
  if (!startDate && !endDate) return params;

  const keyMap = {
    approved: ["approvedFrom", "approvedTo"],
    rejected: ["rejectedFrom", "rejectedTo"],
    created: ["createdFrom", "createdTo"],
    due: ["dueFrom", "dueTo"],
    submitted: ["submittedFrom", "submittedTo"],
  };

  const [fromKey, toKey] = keyMap[kind] || keyMap.submitted;

  if (startDate) params[fromKey] = moment(startDate).format("YYYY-MM-DD");
  if (endDate) params[toKey] = moment(endDate).format("YYYY-MM-DD");
  return params;
};

/**
 * Inclusive calendar-day range check for a single date value.
 */
export const isDateInRange = (value, startDate, endDate) => {
  if (!startDate && !endDate) return true;
  if (!value) return false;

  const day = moment(value);
  if (!day.isValid()) return false;

  if (startDate) {
    const from = moment(startDate).startOf("day");
    if (day.isBefore(from)) return false;
  }
  if (endDate) {
    const to = moment(endDate).endOf("day");
    if (day.isAfter(to)) return false;
  }
  return true;
};

/**
 * Client-side filter using the same date field the table displays.
 */
export const filterItemsByDateRange = (items, kind, startDate, endDate) => {
  if (!Array.isArray(items) || (!startDate && !endDate)) return items || [];
  return items.filter((item) =>
    isDateInRange(getDateForKind(item, kind), startDate, endDate)
  );
};
